import { useTheme, css } from 'styled-components';

import { convertRemToPx } from '@hivebrite/design-system/Theme';

import { FONT_SIZES, valuesToOptions } from 'hb-builder/utils/fonts';
import Select from 'hb-react/shared/components/DesignSystem/Inputs/Select';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const SizeTool = ({ onItemClick, value }) => {
  const theme = useTheme();

  const { quillRef } = useQuillEditorContext();

  const handleChangeFontSize = (e) =>
    quillRef.current.format('customFontSize', `${e?.target?.value}px`, 'user');

  return (
    <ToolbarItem
      css={css`
        width: 30%;
      `}
      isActive
    >
      <Select
        fontSize={13}
        height={25}
        hideLabel
        iconSpaceRight={theme.space[2]}
        id="builder-selection-font-size"
        label={__('Font size')}
        lineHeight={1.4}
        name="font-size"
        onChange={handleChangeFontSize}
        onClick={onItemClick}
        options={valuesToOptions(FONT_SIZES, (value) => `${value}px`)}
        value={value || convertRemToPx(theme.fontSizes[2])}
        size="extra-small"
        width="100%"
      />
    </ToolbarItem>
  );
};

SizeTool.getFormat = (format, quill) =>
  parseInt(
    format?.customFontSize || window.getComputedStyle(quill.container).fontSize,
    10,
  );

export default SizeTool;
